<template>
  <footer id="kt_footer" class="natcon-footer-wrapper">
    <div class="container-fluid px-4">
      <div class="footer-content-row">
        <!-- Copyright & JCI India Branding -->
        <div class="footer-left">
          <span class="footer-copy">{{ CurrentYear }} ©</span>
          <a href="https://jciindia.in" target="_blank" class="footer-brand-link">
            JCI India National Headquarters
          </a>
        </div>

        <!-- Version & Info -->
        <div class="footer-center" v-if="AppVersion || VersionInfo">
          <span class="version-badge">v{{ AppVersion }}</span>
          <span v-if="VersionInfo" class="version-note ml-2">{{ VersionInfo }}</span>
        </div>

        <!-- Powered By -->
        <div class="footer-right">
          <span class="powered-text">Powered by</span>
          <a href="http://vaagai.org.in" target="_blank" class="powered-link">
            Vaagai Tecknowledge
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { version } from "/package.json";
import common from "@/Common.vue";

export default {
  name: "KTFooter",
  mixins: [common],
  data() {
    return {
      AppVersion: version,
      VersionInfo: "",
      CurrentYear: new Date().getFullYear(),
    };
  },
  beforeMount() {
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 5,
    };
    this.getPageDetails("VersionInfo", "", url2, condition2);
  },
};
</script>

<style scoped lang="scss">
.natcon-footer-wrapper {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-top: 1px solid var(--jci-border);
  padding: 1.25rem 0;
  margin-top: auto;
  transition: all 0.3s ease;
}

.footer-content-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-left {
  display: flex;
  align-items: center;
  font-size: 0.825rem;
  color: #64748B;

  .footer-copy {
    font-weight: 500;
    margin-right: 0.5rem;
  }

  .footer-brand-link {
    color: var(--jci-navy);
    font-weight: 700;
    text-decoration: none !important;
    transition: color 0.2s ease;

    &:hover {
      color: var(--jci-aqua);
    }
  }
}

.footer-center {
  display: flex;
  align-items: center;
  justify-content: center;

  .version-badge {
    background: rgba(58, 103, 177, 0.08);
    border: 1px solid rgba(58, 103, 177, 0.2);
    color: var(--jci-navy);
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
  }

  .version-note {
    font-size: 0.75rem;
    color: #64748B;
  }
}

.footer-right {
  display: flex;
  align-items: center;
  font-size: 0.825rem;
  color: #64748B;

  .powered-text {
    margin-right: 0.4rem;
  }

  .powered-link {
    color: var(--jci-dark-navy);
    font-weight: 600;
    text-decoration: none !important;
    transition: color 0.2s ease;

    &:hover {
      color: var(--jci-navy);
    }
  }
}

@media (max-width: 768px) {
  .footer-content-row {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
}
</style>
